require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.map");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.split");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "vant/es/toast/style", "vant/es/toast"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("vant/es/toast/style"), require("vant/es/toast"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.style, global.toast);
    global.qaHistory = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _style, _toast) {
  "use strict";

  var _interopRequireDefault = require("/root/deploy/iot-product-tool/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _toast = _interopRequireDefault(_toast);
  var _default = {
    name: 'XiazengQaHistory',
    data: function data() {
      var _this$$config$base = this.$config.base,
          ossHost = _this$$config$base.ossHost,
          ossHostPond = _this$$config$base.ossHostPond;
      return {
        ossHost: ossHost,
        ossPondHost: ossHostPond,
        loaded: false,
        list: [],
        isShowAll: false,
        uniqueId: '',
        searchId: '',
        pageNo: 1,
        isShowClearBtn: false
      };
    },
    created: function created() {
      this.loadData(); // 初始化微信 JSSDK

      this.weixinInit(); // 绑定滚动事件

      window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy: function beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      weixinInit: function weixinInit() {
        var vm = this;
        vm.$http({
          method: 'GET',
          url: "https://m.yudada.com/jssdk/configuration?url=".concat(location.href)
        }).then(function (res) {
          var _res$data = res.data,
              appId = _res$data.appId,
              nonceStr = _res$data.nonceStr,
              signature = _res$data.signature,
              timestamp = _res$data.timestamp;
          window.wx.config({
            debug: false,
            appId: appId,
            timestamp: timestamp,
            nonceStr: nonceStr,
            signature: signature,
            jsApiList: ['scanQRCode']
          });
        });
      },
      onclickSearchBtn: function onclickSearchBtn() {
        var vm = this;

        if (vm.uniqueId.length != 8) {
          (0, _toast.default)('请输入8位设备编码');
          return;
        }

        vm.searchId = vm.uniqueId;
        vm.pageNo = 1;
        vm.loadData();
      },
      // 加载质检记录
      loadData: function loadData() {
        var vm = this;
        var url = "xia/factory/qcHistory?pageSize=20&pageNo=".concat(vm.pageNo);

        if (vm.searchId) {
          url += "&uniqueId=".concat(vm.searchId);
        }

        vm.$http({
          method: 'GET',
          url: vm.$config.base.XIAZENG_BASE_URL + url
        }).then(function (res) {
          var data = res.data || {};
          var records = data.records || [];
          var total = data.total || 0;
          records.map(function (item) {
            item.time = vm.$time.formateTime(new Date(item.submitTime).getTime(), 'm-d h:f');
          });
          var list = vm.pageNo === 1 ? records : vm.list.concat(records);
          vm.loaded = true;
          vm.list = list;
          vm.isShowAll = list.length >= total;
        }).catch(function () {
          vm.loaded = true;
        });
      },
      // 滚动加载更多
      handleScroll: function handleScroll() {
        var vm = this;
        if (vm.isShowAll) return;
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        var scrollHeight = document.documentElement.scrollHeight;
        var clientHeight = document.documentElement.clientHeight;

        if (scrollTop + clientHeight >= scrollHeight - 50) {
          vm.pageNo++;
          vm.loadData();
        }
      },
      inputChange: function inputChange() {
        var vm = this;

        if (!vm.uniqueId) {
          vm.searchId = '';
          vm.pageNo = 1;
          vm.loadData();
        }

        vm.isShowClearBtn = !!vm.uniqueId;
      },
      // 扫码搜索
      onclickScanBtn: function onclickScanBtn() {
        var vm = this;

        if (window.wx && window.wx.scanQRCode) {
          window.wx.scanQRCode({
            needResult: 1,
            scanType: ['qrCode'],
            success: function success(res) {
              var result = res.resultStr;

              if (!(result && result.split('deviceId=')[1])) {
                (0, _toast.default)('编号错误，请确认后重试');
                return;
              }

              var encodeId = result.split('deviceId=')[1]; // 根据加密的设备ID获取8位uniqueID

              vm.$http({
                method: 'GET',
                url: vm.$config.base.PROBE_BASE_URL + "device/info?encodeId=".concat(encodeId)
              }).then(function (rs) {
                vm.uniqueId = rs.data.uniqueId;
                vm.isShowClearBtn = true;
                vm.searchId = rs.data.uniqueId;
                vm.pageNo = 1;
                vm.loadData();
              });
            }
          });
        } else {
          (0, _toast.default)('请在微信中扫码');
        }
      },
      // 查看某一记录的质检详情
      onclickListItem: function onclickListItem(item) {
        this.$router.push({
          path: './qaDetail',
          query: {
            info: JSON.stringify(item)
          }
        });
      }
    }
  };
  _exports.default = _default;
});